import { c as _c } from "react/compiler-runtime";
import { Link, type LinkProps } from '@/components/links';
import { type ReactNode } from 'react';
import IconArrow from '@/assets/icons/heroIcons/Arrow-right.svg';
import { mergeClasses } from '@/utils/style';
import { Text, Headline } from '@/components/typography';
interface SectionProps {
  icon: ReactNode;
  title: string;
  anchorKey?: string;
  description: ReactNode;
  link: LinkProps;
  variant?: 'inverted' | 'primary';
}
export function ProductBox(props) {
  const $ = _c(35);
  const {
    anchorKey,
    description,
    icon,
    link,
    title,
    variant: t0
  } = props;
  const variant = t0 === undefined ? "inverted" : t0;
  const t1 = variant === "inverted" && "hover:text-light-gray-100 bg-white text-gray-700 hover:bg-blue-500";
  const t2 = variant === "primary" && "bg-blue-500 text-white hover:bg-blue-700";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = mergeClasses("group relative h-full rounded-2xl px-4 pt-6 pb-[4.25rem] shadow-xs transition sm:px-6 md:rounded-4xl md:px-8 md:pt-8", t1, t2);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = variant === "inverted" && "text-blue-500 group-hover:text-white";
  let t5;
  if ($[3] !== t4) {
    t5 = mergeClasses("iconContainer h-9 w-9 shrink-0 md:h-11 md:w-11", t4);
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== icon || $[6] !== t5) {
    t6 = <div className={t5}>{icon}</div>;
    $[5] = icon;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== anchorKey || $[9] !== title) {
    t7 = <Headline as="h3" variant="h5" anchorKey={anchorKey}>{title}</Headline>;
    $[8] = anchorKey;
    $[9] = title;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <div className="flex flex-row items-center gap-4">{t6}{t7}</div>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = variant === "inverted" && "text-gray-700 group-hover:text-white";
  let t10;
  if ($[14] !== t9) {
    t10 = mergeClasses(t9);
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== description || $[17] !== t10) {
    t11 = <Text as="div" variant="p3" className={t10}>{description}</Text>;
    $[16] = description;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = variant === "inverted" && "bg-blue-500 text-white md:bg-blue-100 md:text-blue-500 md:group-hover:bg-blue-500 md:group-hover:text-white";
  const t13 = variant === "primary" && "bg-blue-700 text-white";
  let t14;
  if ($[19] !== t12 || $[20] !== t13) {
    t14 = mergeClasses("absolute right-0 bottom-0 flex h-12 w-12 items-center justify-center rounded-tl-2xl rounded-br-2xl transition md:h-18 md:w-18 md:rounded-tl-4xl md:rounded-br-4xl", t12, t13);
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <IconArrow className="h-4 w-4 md:h-6 md:w-6" />;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t14) {
    t16 = <div className={t14}>{t15}</div>;
    $[23] = t14;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t11 || $[26] !== t16 || $[27] !== t8) {
    t17 = <div className="flex flex-col gap-3 md:gap-6">{t8}{t11}{t16}</div>;
    $[25] = t11;
    $[26] = t16;
    $[27] = t8;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t17 || $[30] !== t3) {
    t18 = <div className={t3}>{t17}</div>;
    $[29] = t17;
    $[30] = t3;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== link || $[33] !== t18) {
    t19 = <Link {...link} className="no-underline">{t18}</Link>;
    $[32] = link;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  return t19;
}